import React, { useRef, useEffect, useState } from "react";
import ReactPlayer from "react-player/lazy";

import testimonialicon from "../../images/testimonialicon.png";
import Ellipse1 from "../../images/Ellipse1.png";
import Ellipse2 from "../../images/Ellipse2.png";
import Ellipse3 from "../../images/Ellipse3.png";
import Ellipse4 from "../../images/Ellipse4.png";
import Ellipse5 from "../../images/Ellipse5.png";
import rate1 from "../../images/rate1.png";
import rate2 from "../../images/rate2.png";
import playicon from "../../images/playicon.png";
import { motion } from 'framer-motion';
const Testimonial = ({ videos = [] }) => {
  const playerRef = useRef(null);

  const [playing, setPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);

  const [current, setCurrent] = useState({
    thumbnail: "",
    video: "",
    name: "",
    role: "",
  });

  const togglePlay = () => setPlaying((p) => !p);

  useEffect(() => {
    if (videos?.length > 0) {
      setCurrent({
        thumbnail: videos[0].thumbnail_url,
        video: videos[0].video_url,
        name: videos[0].username,
        role: videos[0].user_occupation,
      });
    }
  }, [videos]);


  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12,
      },
    },
  };

  const card = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };
  const testimonials = [
    {
      name: "Hillary Abeke",
      role: "Trader",
      image: Ellipse5,
      text:
        "Before the app, managing logistics was tough. Now it's easy.",
      rating: rate1,
    },
    {
      name: "Anna Chijioke",
      role: "Sales Manager",
      image: Ellipse1,
      text:
        "Pickload changed my delivery experience completely.",
      rating: rate2,
    },
    {
      name: "Mary Igwokhai",
      role: "Logistics Agent",
      image: Ellipse2,
      text:
        "Everything is now smoother and faster.",
      rating: rate1,
    },
    {
      name: "John Raphael",
      role: "Entrepreneur",
      image: Ellipse3,
      text:
        "Real-time tracking transformed my business.",
      rating: rate2,
    },
    {
      name: "Olumide Daramola",
      role: "Trader",
      image: Ellipse4,
      text:
        "Reliable delivery system that works perfectly.",
      rating: rate1,
    },
  ];

  return (
    <div className="w-full py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-10 px-4">

        {/* LEFT SIDE */}
        <div className="flex-1 space-y-4">

          <img
            src={testimonialicon}
            className="w-24 mb-4"
            alt=""
          />

          {/* STATIC TESTIMONIALS */}
          <motion.div
            variants={container}
            initial="hidden"
            animate="show"
            className="flex-1 space-y-4"
          >
            {/* <img src={testimonialicon} className="w-24 mb-4" alt="" /> */}

            {testimonials.map((t, i) => (
              <motion.div
                key={i}
                variants={card}
                whileHover={{
                  scale: 1.03,
                  y: -6,
                }}
                transition={{ type: "spring", stiffness: 200 }}
                className="
        relative
        bg-white/80
        backdrop-blur-xl
        rounded-3xl
        p-6
        border
        border-gray-100
        shadow-sm
        hover:shadow-2xl
        overflow-hidden
      "
              >
                {/* glow */}
                <div className="
        absolute -top-10 -right-10 w-32 h-32
        bg-green-400/20 rounded-full blur-3xl
      " />

                <div className="flex items-center gap-3 relative z-10">
                  <img
                    src={t.image}
                    className="w-12 h-12 rounded-full border-2 border-green-400"
                  />
                  <div>
                    <h2 className="font-bold">{t.name}</h2>
                    <p className="text-xs text-gray-500">{t.role}</p>
                  </div>
                </div>

                <p className="text-sm text-gray-600 mt-4 relative z-10">
                  “{t.text}”
                </p>

                <div className="mt-4 flex justify-between relative z-10">
                  <img src={t.rating} className="w-24" />
                  <span className="text-xs text-green-600 font-semibold">
                    Verified
                  </span>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>

        {/* RIGHT SIDE */}
        <div className="flex-1">

          {/* VIDEO PLAYER */}
          <div className="relative rounded-2xl overflow-hidden shadow-xl h-[350px] bg-black">
            <ReactPlayer
              ref={playerRef}
              url={current.video}
              light={current.thumbnail}
              width="100%"
              height="100%"
              playing={playing}
              muted={isMuted}
              playIcon={
                <img
                  src={playicon}
                  className="w-16 cursor-pointer"
                  onClick={togglePlay}
                />
              }
            />
          </div>

          {/* THUMBNAILS */}
          <div className="flex gap-3 mt-4 overflow-x-auto">

            {videos.map((v, i) => (
              <img
                key={i}
                src={v.thumbnail_url}
                onClick={() => {
                  setCurrent({
                    thumbnail: v.thumbnail_url,
                    video: v.video_url,
                    name: v.username,
                    role: v.user_occupation,
                  });
                  setPlaying(true);
                }}
                className="w-16 h-16 rounded-lg object-cover cursor-pointer border-2 border-transparent hover:border-green-500"
              />
            ))}

          </div>

          {/* USER INFO */}
          <div className="mt-3">
            <h3 className="font-bold text-lg">{current.name}</h3>
            <p className="text-gray-500">{current.role}</p>
          </div>

        </div>

      </div>
    </div>
  );
};

export default Testimonial;